module.exports = __webpack_public_path__ + "static/media/mama.dde4d7a1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/mp3/mama.mp3
// module id = 40
// module chunks = 0